import React, { useEffect, useRef, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useNavigate , Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { doRequest } from "../utils/helper";
// import Varient from "../assets/img/varient.png";
// import titleimg from "../assets/img/Layer_1-2.svg";
import "../design/css/login.css"
import teedexlogo from "../assets/loginimg/teedexlogo.svg"
import logoutIcon from "../assets/loginimg/logouticn.svg"

export default function VerifyForgetPasswordOtp() {
  const navigate = useNavigate();
  const digit1 = useRef();
  const digit2 = useRef();
  const digit3 = useRef();
  const digit4 = useRef();
  const digit5 = useRef();
  const digit6 = useRef();
  const [errmsg, setErrorMsg] = useState(null);

  var email_id = localStorage.getItem("users_email");

  const handleInputChange1 = (e) => {
    if (e.target.value != "") {
      digit2.current.focus();
    }
  };
  const handleInputChange2 = (e) => {
    if (e.target.value != "") {
      digit3.current.focus();
    }
  };
  const handleInputChange3 = (e) => {
    if (e.target.value != "") {
      digit4.current.focus();
    }
  };
  const handleInputChange4 = (e) => {
    if (e.target.value != "") {
      digit5.current.focus();
    }
  };
  const handleInputChange5 = (e) => {
    if (e.target.value != "") {
      digit6.current.focus();
    }
  };

  const resendOtp = async () => {
    try {
      let data = {
        email: email_id,
      };
      let response = await doRequest(data, "POST", "user/resend-otp");
      if (+response?.resultFlag === 1) {
        alert("email sent");
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong!"
        );
      }
    } catch (error) {
      setErrorMsg(error?.message ? error?.message : "Something went wrong!");
    }
  };

  var verify_otp = async (e) => {
    e.preventDefault();

    var dataToPost = {
      email: email_id,
      otp:
        digit1.current.value +
        digit2.current.value +
        digit3.current.value +
        digit4.current.value +
        digit5.current.value +
        digit6.current.value,
    };
    try {
      const response = await doRequest(
        dataToPost,
        "POST",
        "user/verify-forgot-pwd"
      );
      if (+response?.resultFlag == 1) {
        navigate("/new-password");
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong!"
        );
      }
    } catch (error) {
      setErrorMsg(error?.message ? error?.message : "Something went wrong!");
    }
  };

  useEffect(() => {
    digit1.current.focus();
  }, []);
  return (
    <>
      {/* <div id="main-container" className="container-fluid main">
        <div className="sidemenu d-flex flex-column justifycontent-between min-vh-100">
          <div className="text-center mt-3">
            <ul className="nav nav-pills flex-column">
              <li>
                <img
                  src={Varient}
                  alt="Varient logo"
                  style={{ width: "50px", top: 0 }}
                />
              </li>
            </ul>
          </div>
        </div>

        <section className="home">
          <div className="container login-container">
            <div className="row mt-4">
              <div className="mb-4">
                <ul className="d-flex col-11 login-tabs">
                  <li className="">Signup</li>
                  <li className="mx-2">Payment</li>
                  <li className="mx-2">Register</li>
                </ul>
              </div>
            </div>
            <div className="row my-5">
              <div className="col-5">
                <div className="login">
                  <h3 className="text-center mb-2">Check you email</h3>
                  <p>We sent you the OTP to {email_id}</p>

                  <form onSubmit={(e) => verify_otp(e)}>
                    <p className="text-left mb-1 mt-6">Verify OTP</p>
                    <div className="otp-input-div">
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit1}
                        onChange={(e) => handleInputChange1(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit2}
                        onChange={(e) => handleInputChange2(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit3}
                        onChange={(e) => handleInputChange3(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit4}
                        onChange={(e) => handleInputChange4(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit5}
                        onChange={(e) => handleInputChange5(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit6}
                        onChange={(e) => handleInputChange4(e)}
                      />
                    </div>
                    <input
                      className="submit"
                      type="submit"
                      value="Verify OTP"
                    />
                  </form>
                  <div className="my-4 text-center">
                    <p>Didn't receive email ?</p>
                    <a onClick={() => resendOtp()} className="login-a mx-2">
                      Resend OTP
                    </a>
                    <p className="text-danger">
                      {errmsg != null ? errmsg : ""}
                    </p>
                  </div>
                  <div className="my-4 text-center">
                    <FontAwesomeIcon
                      icon={faArrowRightFromBracket}
                      rotation={180}
                      size="xs"
                      style={{ color: "#2A1FB3" }}
                    />
                    <a href="/Login" className="login-a mx-2">
                      Back to Login
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-7 d-flex justify-content-center align-items-center">
                <div className="login-title">
                  <img src={titleimg} alt="title" />
                  <p>Join the Crafters</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}

       <div className="newLoginBody">
        <div className="newLoginBodyText" style={{ padding: "0 12.635vw"}}>
            <div className="newLoginFormContainer newLoginFormBlock" style={{ padding: "2vw"}}>
                <h1>Check you email</h1>
                <p>We sent you the OTP to {email_id}</p>
                <div className={`otpInputs ${errmsg ? "wrongOtp" : ""}`}
                 style={{ width: "20.885vw"}}>
                    <p>{errmsg ? "Wrong OTP" : "Verify OTP"}</p>
                    <form onSubmit={(e) => verify_otp(e)}>
<div className="otpInputList" style={{ flexWrap: "nowrap"}}>
                        <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                             <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit1}
                        onChange={(e) => handleInputChange1(e)}
                      />
                        </div>
                        <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                             <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit2}
                        onChange={(e) => handleInputChange2(e)}
                      />
                        </div>
                        <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                            <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit3}
                        onChange={(e) => handleInputChange3(e)}
                      />
                        </div>
                        <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                             <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit4}
                        onChange={(e) => handleInputChange4(e)}
                      />
                        </div>
                         <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                             <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit5}
                        onChange={(e) => handleInputChange5(e)}
                      />
                        </div>
                         <div className="inputContainer">
                            {/* <input type="text" maxlength="1" class="otpInput" placeholder="-" /> */}
                             <input
                        className="otpInput"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit6}
                        onChange={(e) => handleInputChange4(e)}
                      />
                        </div>
                    </div>
                     <div className="inputContainer">
                    <button type="submit" className="loginButton">Verify OTP</button>
                </div>
                    </form>
                    
                </div>

<p style={{margin: "0"}} className="text-danger">
                      {errmsg != null ? errmsg : ""}
                    </p>
               
                <div className="didntGet">
                    Didn’t get an email? <a onClick={() => resendOtp()}>Resend</a>
                </div>
                <div className="forgotPassword">
                    <Link to={"/login"}><img src={logoutIcon} alt="" /> Back to Login</Link>
                </div>
            </div>
            <div className="formTnc newLoginFormBlock">
                By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
            </div>
            <div className="formTeedexLogo newLoginFormBlock">
                <img src={teedexlogo} alt="Teedex Logo" />
            </div>
            <div className="formCopyR newLoginFormBlock">© 2024 Teedex All Rights Reserved</div>
        </div>

        <div className="newLoginBodyImg"></div>
    </div>


     


    </>
  );
}
